<template>
  <div id="app" :class="{ 'dark-mode': $store.state.darkMode }">
    <TopBar></TopBar>    
    <div class="main">
    
      <router-view>
      </router-view>
      
    </div>
    <FloatingSubscriptionWidget />
    <MobileMiniProgramPrompt />
    <SubscriptionFollowDialog />
    <GlobalCoinDialogs />
    <!-- <ProgressCircle :percent="0.5"></ProgressCircle> -->
  </div>
</template>

<script>

import TopBar from './components/TopBar.vue'
import ProgressCircle from  './components/progress-circle.vue'
import GlobalCoinDialogs from './components/GlobalCoinDialogs.vue'
import SubscriptionFollowDialog from './components/SubscriptionFollowDialog.vue'
import FloatingSubscriptionWidget from './components/FloatingSubscriptionWidget.vue'
import MobileMiniProgramPrompt from './components/MobileMiniProgramPrompt.vue'
export default {
  name: 'App',
  components: {  
    TopBar,
    ProgressCircle,
    GlobalCoinDialogs,
    SubscriptionFollowDialog,
    FloatingSubscriptionWidget,
    MobileMiniProgramPrompt
  },
  mounted() {
    this.loadRuntimeFlags()
    // 暗黑模式 body 背景色兼容性处理（替代 body:has() 选择器）
    if (this.$store.state.darkMode) document.body.classList.add('dark-mode-body')
    else document.body.classList.remove('dark-mode-body')
    // 链接直登：URL 带 autologin=token 时，用 token 换登录态并清除地址栏参数
    const autologinToken = this.$route.query.autologin
    if (autologinToken && typeof autologinToken === 'string') {
      this.$axios.get('/user/autologin', { params: { token: autologinToken } }).then(res => {
        if (res.data && res.data.token) {
          const u = res.data.user || {}
          this.$store.commit('SetUser', {
            token: res.data.token,
            username: u.username || '',
            coins: u.coins != null ? u.coins : 0,
            id: u.id
          })
          this.$message({ message: '已通过链接进入，欢迎使用', type: 'success' })
          const q = { ...this.$route.query }
          delete q.autologin
          this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
        }
      }).catch(() => {
        this.$message({ message: '链接已失效或已过期', type: 'warning' })
        const q = { ...this.$route.query }
        delete q.autologin
        this.$router.replace({ path: this.$route.path, query: q }).catch(() => {})
      })
      return
    }
    // 刷新页面时从服务器同步最新金币（避免数据库改后前端仍显示旧值）
    const user = this.$store.state.user
    if (user && user.token) {
      this.$axios.get('/user/profile', { params: { token: user.token } }).then(res => {
        if (res.data && res.data.coins != null) this.$store.commit('SetUserCoins', res.data.coins)
        if (res.data && res.data.hideFollowOfficialEarn != null) {
          this.$store.commit('SetUserHideFollowOfficialEarn', !!res.data.hideFollowOfficialEarn)
        }
      }).catch(() => {})
      // 同步暗黑模式偏好
      this.$axios.get('/user/dark-mode', { params: { token: user.token } }).then(res => {
        if (res.data && res.data.darkMode != null) this.$store.commit('SetDarkMode', !!res.data.darkMode)
      }).catch(() => {})
    }
    // 分享链接点击追踪
    const inviteCode = this.$route.query.invite
    if (inviteCode && typeof inviteCode === 'string') {
      this.$axios.post('/share/click', { inviteCode }).catch(() => {})
    }
  },
  methods: {
    loadRuntimeFlags() {
      this.$axios.get('/app/runtime-flags').then(res => {
        const data = res.data || {}
        this.$store.commit('SetCoinFeatureModes', {
          coinChargeEnabled: data.coinChargeEnabled !== false,
          freeModeNotice: data.freeModeNotice || '',
          legacyCoinFeatureEnabled: data.legacyCoinFeatureEnabled !== false,
          miniProgramCoinFeatureEnabled: !!data.miniProgramCoinFeatureEnabled
        })
      }).catch(() => {})
    }
  },
  watch: {
    '$store.state.darkMode'(val) {
      if (val) document.body.classList.add('dark-mode-body')
      else document.body.classList.remove('dark-mode-body')
    }
  }
}
</script>

<style lang="less" scoped>
    @media(min-width: 769px) {
      .main {
        width: 1200px;
        margin: 10px auto;
        min-width: 1200px;
        
      }     
    }
  
    @media(max-width: 768px) {
      .main {
        width: 100%;
        max-width: 100vw;
        padding: 8px 0;
        box-sizing: border-box;
      }
    }
</style>

<!-- 暗黑模式全局 CSS 变量 + Element UI 覆盖（非 scoped） -->
<style lang="less">
/* ===== 浅色主题（默认） ===== */
#app {
  --bg-primary: #fff;
  --bg-secondary: #f5f7fa;
  --bg-card: #fff;
  --text-primary: #303133;
  --text-regular: #606266;
  --text-secondary: #909399;
  --border-color: #ebeef5;
  --border-light: #f0f0f0;
  --shadow-color: rgba(0, 0, 0, 0.06);
  --hover-bg: #ecf5ff;
  --input-bg: #fff;
  --table-header-bg: #f5f7fa;
  --dialog-bg: #fff;
  --topbar-bg: linear-gradient(180deg, #fff 0%, #f5f7fa 100%);
  --tag-bg: #f4f4f5;
  --tip-bg: #ecf5ff;
  --tip-border: #d9ecff;
}

/* ===== 暗黑主题 ===== */
#app.dark-mode {
  --bg-primary: #1a1a2e;
  --bg-secondary: #16213e;
  --bg-card: #1e2a3a;
  --text-primary: #e0e0e0;
  --text-regular: #b0b0b0;
  --text-secondary: #808080;
  --border-color: #333a4a;
  --border-light: #2a3040;
  --shadow-color: rgba(0, 0, 0, 0.3);
  --hover-bg: rgba(64, 158, 255, 0.15);
  --input-bg: #1e2a3a;
  --table-header-bg: #16213e;
  --dialog-bg: #1e2a3a;
  --topbar-bg: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  --tag-bg: #2a3040;
  --tip-bg: rgba(64, 158, 255, 0.1);
  --tip-border: #333a4a;

  background-color: var(--bg-primary);
  color: var(--text-primary);
}

/* body 暗黑背景（通过 JS 添加 class，兼容旧浏览器） */
body.dark-mode-body {
  background-color: #1a1a2e;
}

.v-modal {
  background: rgba(15, 23, 42, 0.22) !important;
  backdrop-filter: blur(12px) saturate(120%);
  -webkit-backdrop-filter: blur(12px) saturate(120%);
}

.el-dialog,
.el-message-box,
.el-drawer,
.el-popover,
.el-select-dropdown,
.el-dropdown-menu,
.el-picker-panel,
.el-autocomplete-suggestion,
.el-cascader__dropdown,
.el-notification {
  border-radius: 22px !important;
}

.el-dialog,
.el-message-box,
.el-drawer {
  overflow: hidden;
  box-shadow: 0 28px 80px rgba(15, 23, 42, 0.18);
}

.el-dialog__header,
.el-message-box__header {
  padding-top: 18px;
}

.el-dialog__body,
.el-message-box__content {
  padding-bottom: 24px;
}

.el-drawer__header {
  margin-bottom: 0;
  padding: 18px 20px;
}

body.dark-mode-body .v-modal {
  background: rgba(3, 7, 18, 0.34) !important;
}

body.dark-mode-body .el-dialog,
body.dark-mode-body .el-message-box,
body.dark-mode-body .el-drawer {
  box-shadow: 0 28px 80px rgba(0, 0, 0, 0.42);
}

/* ===== 暗黑模式 Element UI 全局覆盖 ===== */
#app.dark-mode {
  /* Dialog */
  .el-dialog {
    background: var(--dialog-bg);
    border: 1px solid var(--border-color);
  }
  .el-dialog__title { color: var(--text-primary); }
  .el-dialog__header { border-bottom-color: var(--border-color); }
  .el-dialog__body { color: var(--text-regular); }

  /* Table */
  .el-table {
    background-color: var(--bg-card);
    color: var(--text-regular);
    &::before { background-color: var(--border-color); }
    th { background-color: var(--table-header-bg) !important; color: var(--text-primary); }
    tr { background-color: var(--bg-card); }
    td { border-bottom-color: var(--border-color); }
    .el-table__row:hover > td { background-color: var(--hover-bg) !important; }
    .el-table__row--striped > td { background-color: var(--bg-secondary) !important; }
    .el-table__empty-text { color: var(--text-secondary); }
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
    background-color: var(--hover-bg) !important;
  }

  /* Input / Select / Textarea */
  .el-input__inner,
  .el-textarea__inner {
    background-color: var(--input-bg);
    color: var(--text-primary);
    border-color: var(--border-color);
  }
  .el-input__inner::placeholder,
  .el-textarea__inner::placeholder { color: var(--text-secondary); }
  .el-input__inner:focus,
  .el-textarea__inner:focus { border-color: #409eff; }
  .el-input-number__decrease,
  .el-input-number__increase {
    background: var(--bg-secondary);
    color: var(--text-regular);
    border-color: var(--border-color);
  }

  /* Select Dropdown */
  .el-select-dropdown {
    background-color: var(--bg-card);
    border-color: var(--border-color);
  }
  .el-select-dropdown__item {
    color: var(--text-regular);
    &.hover, &:hover { background-color: var(--hover-bg); }
    &.selected { color: #409eff; }
  }
  .el-popper[x-placement^=bottom] .popper__arrow::after { border-bottom-color: var(--bg-card); }
  .el-popper[x-placement^=top] .popper__arrow::after { border-top-color: var(--bg-card); }

  /* Button */
  .el-button--default {
    background-color: var(--bg-secondary);
    color: var(--text-regular);
    border-color: var(--border-color);
    &:hover { color: #409eff; border-color: #409eff; background-color: var(--hover-bg); }
  }

  /* Collapse */
  .el-collapse { border-color: var(--border-color); }
  .el-collapse-item__header {
    background-color: var(--bg-card);
    color: var(--text-primary);
    border-bottom-color: var(--border-color);
  }
  .el-collapse-item__wrap {
    background-color: var(--bg-card);
    border-bottom-color: var(--border-color);
  }
  .el-collapse-item__content { color: var(--text-regular); }

  /* Radio */
  .el-radio__label { color: var(--text-regular); }
  .el-radio-button__inner {
    background-color: var(--bg-secondary);
    color: var(--text-regular);
    border-color: var(--border-color);
  }
  .el-radio-group .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    background-color: #409eff;
    color: #fff;
    border-color: #409eff;
  }

  /* Tag */
  .el-tag--info {
    background-color: var(--tag-bg);
    color: var(--text-regular);
    border-color: var(--border-color);
  }

  /* Slider */
  .el-slider__runway { background-color: var(--border-color); }

  /* Checkbox */
  .el-checkbox__inner {
    background-color: var(--input-bg);
    border-color: var(--border-color);
  }

  /* Divider */
  .el-divider { background-color: var(--border-color); }
  .el-divider__text { background-color: var(--bg-card); color: var(--text-secondary); }

  /* Dropdown */
  .el-dropdown-menu {
    background-color: var(--bg-card);
    border-color: var(--border-color);
  }
  .el-dropdown-menu__item {
    color: var(--text-regular);
    &:hover { background-color: var(--hover-bg); color: #409eff; }
  }

  /* Message Box */
  .el-message-box {
    background: var(--dialog-bg);
    border-color: var(--border-color);
  }
  .el-message-box__title { color: var(--text-primary); }
  .el-message-box__message { color: var(--text-regular); }

  /* Date Picker */
  .el-date-picker {
    background: var(--bg-card);
    border-color: var(--border-color);
    color: var(--text-primary);
  }
  .el-picker-panel { background: var(--bg-card); border-color: var(--border-color); color: var(--text-primary); }
  .el-picker-panel__body { color: var(--text-regular); }
  .el-date-table th { color: var(--text-secondary); }
  .el-date-table td.normal .el-date-table-cell__text { color: var(--text-regular); }

  /* Upload */
  .el-upload-dragger {
    background-color: var(--bg-secondary);
    border-color: var(--border-color);
  }

  /* Form */
  .el-form-item__label { color: var(--text-regular); }

  /* Loading */
  .el-loading-mask { background-color: rgba(26, 26, 46, 0.8); }
  .el-loading-text { color: var(--text-regular); }
  .el-loading-spinner .path { stroke: #409eff; }
  .el-loading-spinner i { color: #409eff; }

  /* Link */
  .el-link.el-link--default { color: var(--text-regular); }

  /* Pagination */
  .el-pagination .btn-prev,
  .el-pagination .btn-next { background: var(--bg-secondary); color: var(--text-regular); }
  .el-pager li { background: var(--bg-secondary); color: var(--text-regular); }
  .el-pager li.active { color: #409eff; }

  /* Scrollbar */
  .el-scrollbar__thumb { background-color: var(--text-secondary); }
}
</style>
